import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bulkPlaylistsUpdateAccept, deletePlaylistItem, bulkPlaylistsUpdateDeny, bulkDeletePlaylist } from 'signoxe/actions';
import { Box } from 'signoxe/components/layout';
import { Button, Popup } from 'signoxe/components/widgets';
import { getbulkUpdatePlaylists } from 'signoxe/selectors';
import './styles.scss';
import {
  PLAYLIST_ITEMS_RESOURCE,

} from "signoxe/api/resources";
class BulkConfirmationPopup extends React.Component {
  static propTypes = {
    confirmationState: PropTypes.shape({
      title: PropTypes.string,
      message: PropTypes.string,
      visible: PropTypes.bool.isRequired,
      operation: PropTypes.string,
      resourceType: PropTypes.string,
      id: PropTypes.number,
      playlists: PropTypes.array.isRequired,
    }).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    bulkDeletePlaylist: PropTypes.func.isRequired,
    deletePlaylistItem: PropTypes.func.isRequired,
  };

  handleCancel = () => this.props.onCancel();

  handleBulkDeletePlaylists = (playlist) => this.props.bulkDeletePlaylist(playlist);

  handleConfirm = () => {
    const { operation, resourceType, playlists } = this.props.confirmationState;
    if (resourceType === PLAYLIST_ITEMS_RESOURCE) {
      playlists.forEach((item) => this.props.deletePlaylistItem(item));
      this.props.onCancel();
    }
    else {
      this.props.onConfirm(operation, resourceType, playlists);

    }
  }

  render() {
    const { message, title, visible } = this.props.confirmationState;

    if (visible) {
      return (
        <Popup className="confirmation-popup"
          onCancel={this.handleCancel}
          title={title}
          modal>
          <Box direction="column" justifyContent="center">
            <p>{message}</p>
            <Box direction="row" className="actions button-group">
              <Button className="alert" onClick={this.handleConfirm}>OK</Button>
              <Button secondary onClick={this.handleCancel}>Cancel</Button>
            </Box>
          </Box>
        </Popup>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({ confirmationState: getbulkUpdatePlaylists(state) });

export default connect(mapStateToProps, {
  onConfirm: bulkPlaylistsUpdateAccept,
  onCancel: bulkPlaylistsUpdateDeny,
  bulkDeletePlaylist,
  deletePlaylistItem,
})(BulkConfirmationPopup);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/BulkConfirmationPopup/index.js